let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1phY7")).then(() => parcelRequire('aNOf2'));